import React from 'react';

import Content from './Contentbase';
import Footer from './Footer';

const App = () =>
    <div className='stolo-app App'>
        <Content />
        <Footer />
    </div>;

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js